<template>
  <div class="col-md-3 col-lg-2 header-navbar-outer">
    <div class="w-100">
      <div class="navbar-brand-fixed-outer">
        <header class="navbar navbar-light bg-light flex-md-nowrap">
          <div class="navbar-brand me-0">
            <!-- <div class="navbar-brand-image d-lg-flex d-block justify-content-between">
              <span>
              <img  :src="state.sub_leader_logo"
                class="rounded-circle dashboard-img-border d-block" alt="sub_leader_logo" width="40" height="40" />
              </span>
              <span>
              <img  :src="state.leader_logo"
                class="rounded-circle dashboard-img-border d-block" alt="chairman-photo" width="40" height="40" />
              </span>
            </div> -->

            <div class="navbar-brand-image d-lg-flex d-flex align-items-center">
              <span>
                <img
                  v-if="checkEmpty(state.client_info.maa6)"
                  :src="state.client_partylogo"
                  class="rounded-circle dashboard-img-border d-block"
                  alt="sub_leader_logo"
                  width="40"
                  height="40"
                />
              </span>
              <span class="navbar-brand-label text-start text-uppercase">
                <!-- <div class="col-12 sub-region-label">Sub Region</div> -->
                <div class="col-12 region-label">
                  {{ state.client_partyname }}
                </div>
              </span>
            </div>
          </div>
        </header>
      </div>
      <nav
        id="sidebarMenu"
        class="d-md-block d-lg-block d-sm-block collapse nav-navlink-outer"
      >
        <div class="menubar-brand">
          <div class="menubar-brand-image d-lg-flex d-flex align-items-center">
            <span>
              <img
                v-if="checkEmpty(state.client_info.maa66)"
                :src="state.sub_leader_logo"
                class="rounded-circle dashboard-img-border d-block"
                alt="chairman-photo"
                width="40"
                height="40"
              />
            </span>
            <span class="menubar-brand-label text-start">
              <!-- <div class="col-12 sub-region-label">Sub Region</div> -->
              <div class="col-12 region-label text-capitalize">
                {{ state.client_name }}
              </div>
            </span>
          </div>
        </div>

        <div class="menubar-outer">
          <ul class="nav flex-column" id="accordionNavLinkParent">
            <li
              class="nav-item"
              :class="{ 'active-tab': $route.path === '/dashboard' }"
            >
              <router-link class="nav-link" to="/dashboard"
                ><img
                  src="/assets/images/icon/overview-tab-icon.svg"
                  class="navlink-tab-icon"
                  alt=""
                  height="29.28"
                  width="29.28"
                />Dashboard</router-link
              >
            </li>
            <!-- <div class="text-uppercase mt-3 mb-2">Voters</div> -->
            <li class="nav-item" v-show="state.permission_fks.includes('6')">
              <div :class="{ 'active-tab': $route.path.startsWith('/voters') }">
                <button
                  class="btn btn-toggle align-items-center rounded collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#nav-voter-collapse"
                  aria-expanded="false"
                >
                  <img
                    src="/assets/images/icon/voters-menu-icon.svg"
                    class="navlink-tab-icon"
                    alt=""
                    width="16"
                  />Voters
                </button>
              </div>

              <div
                class="collapse"
                data-bs-parent="#accordionNavLinkParent"
                id="nav-voter-collapse"
              >
                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                  <li v-show="state.permission_fks.includes('12')" :class="{ 'sub-active-tab': $route.path.startsWith('/voters/add') }">
                    <router-link class="nav-link" to="/voters/add"
                      >Add Voter</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('13')" :class="{ 'sub-active-tab': $route.path.startsWith('/voters/incompletevoters') }">
                    <router-link class="nav-link" to="/voters/incompletevoters"
                      >Incomplete Voters</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('14')" :class="{ 'sub-active-tab': $route.path.startsWith('/voters/voterslist') }">
                    <router-link class="nav-link" to="/voters/voterslist"
                      >Voter's List</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('15')" :class="{ 'sub-active-tab': $route.path.startsWith('/voters/mismatchedVoters') }">
                    <router-link
                      class="nav-link disabled-router"
                      to="/voters/mismatchedVoters"
                      >Mismatched Voters</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('17')" :class="{ 'sub-active-tab': $route.path.startsWith('/voters/unassignedvoters') }">
                    <router-link class="nav-link" to="/voters/unassignedvoters"
                      >Unassigned Voters</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('16')" :class="{ 'sub-active-tab': $route.path.startsWith('/voters/search') }">
                    <router-link class="nav-link" to="/voters/search"
                      >Search Voters</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('18')" :class="{ 'sub-active-tab': $route.path.startsWith('/voters/import') }">
                    <router-link class="nav-link" to="/voters/import"
                      >Import Voters</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="nav-item"
              v-show="state.permission_fks.includes('69')"
              :class="{ 'active-tab': $route.path === '/appusers' }"
            >
              <router-link class="nav-link" to="/appusers"
                ><img
                  src="/assets/images/icon/mobile-app-icon.svg"
                  class="navlink-tab-icon"
                  alt=""
                  width="16"
                />App Users</router-link
              >
            </li>
            <li
              class="nav-item"
              v-show="state.permission_fks.includes('67')"
              :class="{ 'active-tab': $route.path === '/birthdays' }"
            >
              <router-link class="nav-link" to="/birthdays"
                ><img
                  src="/assets/images/icon/calendar-line-icon.svg"
                  class="navlink-tab-icon"
                  alt=""
                  width="16"
                />Birthdays</router-link
              >
            </li>
            <li class="nav-item" v-show="state.permission_fks.includes('63')">
              <div
                :class="{ 'active-tab': $route.path.startsWith('/approvals') }"
              >
              <button
                class="btn btn-toggle align-items-center rounded collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#nav-my-request"
                aria-expanded="false"
              >
                <img
                  src="/assets/images/icon/campaign-menu-icon.svg"
                  class="navlink-tab-icon"
                  alt=""
                  width="16"
                />Approvals
              </button>
              </div>
              <div
                class="collapse"
                data-bs-parent="#accordionNavLinkParent"
                id="nav-my-request"
              >
                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                  <li :class="{ 'sub-active-tab': $route.path.startsWith('/approvals/myrequest') }">
                    <router-link class="nav-link" to="/approvals/myrequest"
                      >My Requests</router-link
                    >
                  </li>
                  <li :class="{ 'sub-active-tab': $route.path.startsWith('/approvals/approverequest') }">
                    <router-link class="nav-link" to="/approvals/approverequest"
                      >Requests To Approve</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li class="nav-item" v-show="state.permission_fks.includes('10')">
              <div
                :class="{ 'active-tab': $route.path.startsWith('/campaign') }"
              >
                <button
                  class="btn btn-toggle align-items-center rounded collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#nav-new-campaign-collapse"
                  aria-expanded="false"
                >
                  <img
                    src="/assets/images/icon/campaign-menu-icon.svg"
                    class="navlink-tab-icon"
                    alt=""
                    width="16"
                  />Campaign
                </button>
              </div>

              <div
                class="collapse"
                data-bs-parent="#accordionNavLinkParent"
                id="nav-new-campaign-collapse"
              >
                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                  <li v-show="state.permission_fks.includes('19')" :class="{ 'sub-active-tab': $route.path.startsWith('/campaignListing') }">
                    <router-link class="nav-link" to="/campaignListing"
                      >Campaign Listing</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('20')" :class="{ 'sub-active-tab': $route.path.startsWith('/campaign/campaigntemplate') }">
                    <router-link
                      class="nav-link"
                      to="/campaign/campaigntemplate"
                      >Campaign Template</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>

            <li class="nav-item" v-show="state.permission_fks.includes('25')">
              <div
                :class="{
                  'active-tab': $route.path.startsWith('/karyakartas'),
                }"
              >
                <button
                  class="btn btn-toggle align-items-center rounded collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#nav-upcoming-karyakartas-collapse"
                  aria-expanded="false"
                >
                  <img
                    src="/assets/images/icon/users-tab-icon.svg"
                    class="navlink-tab-icon"
                    alt=""
                    width="16"
                  />Karyakartas
                </button>
              </div>

              <div
                class="collapse"
                data-bs-parent="#accordionNavLinkParent"
                id="nav-upcoming-karyakartas-collapse"
              >
                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                  <li v-show="state.permission_fks.includes('26')" :class="{ 'sub-active-tab': $route.path.startsWith('/karyakartas/add') }">
                    <router-link class="nav-link" to="/karyakartas/add"
                      >Add Karyakarta</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('27')" :class="{ 'sub-active-tab': $route.path.startsWith('/karyakartas/list') }">
                    <router-link class="nav-link" to="/karyakartas/list"
                      >List Karyakartas</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>
            <!-- <div class="text-uppercase mt-2 mb-2">Profile</div> -->
            <li class="nav-item" v-show="state.permission_fks.includes('21')">
              <div :class="{ 'active-tab': $route.path.startsWith('/user') }">
                <button
                  class="btn btn-toggle align-items-center rounded collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#nav-upcoming-users-collapse"
                  aria-expanded="false"
                >
                  <img
                    src="/assets/images/icon/customers-tab-icon.svg"
                    class="navlink-tab-icon"
                    alt=""
                    width="16"
                  />Users
                </button>
              </div>

              <div
                class="collapse"
                data-bs-parent="#accordionNavLinkParent"
                id="nav-upcoming-users-collapse"
              >
                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                  <li v-show="state.permission_fks.includes('22')" :class="{ 'sub-active-tab': $route.path.startsWith('/user/add')}" >
                    <router-link class="nav-link" to="/user/add"
                      >Add User</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('23')" :class="{ 'sub-active-tab': $route.path.startsWith('/user/listing') }">
                    <router-link class="nav-link" to="/user/listing"
                      >List Users</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('24')" :class="{ 'sub-active-tab': $route.path.startsWith('/user/permissionsets') }">
                    <router-link class="nav-link" to="/user/permissionsets"
                      >Permission Sets</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="nav-item"
              v-show="state.permission_fks.includes('62')"
              :class="{ 'active-tab': $route.path === '/jantadarbar' }"
            >
              <router-link class="nav-link" to="/jantadarbar"
                ><img
                  src="/assets/images/icon/campaign-menu-icon.svg"
                  class="navlink-tab-icon"
                  alt=""
                  width="16"
                />Janta Darbar</router-link
              >
            </li>
            <li class="nav-item" v-show="state.permission_fks.includes('32')">
              <div
                :class="{
                  'active-tab': $route.path.startsWith('/cloudtelephony'),
                }"
              >
                <button
                  class="btn btn-toggle align-items-center rounded collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#nav-system-phone-collapse"
                  aria-expanded="false"
                >
                  <img
                    src="/assets/images/icon/cloud-telephony-menu-icon.svg"
                    class="navlink-tab-icon"
                    alt=""
                    width="16"
                  />Cloud Telephony
                </button>
              </div>

              <div
                class="collapse"
                data-bs-parent="#accordionNavLinkParent"
                id="nav-system-phone-collapse"
              >
                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                  <li v-show="state.permission_fks.includes('33')" :class="{ 'sub-active-tab': $route.path.startsWith('/cloudtelephony/virtualnumbers') }">
                    <router-link
                      class="nav-link"
                      to="/cloudtelephony/virtualnumbers"
                      >Virtual Numbers</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('55')" :class="{ 'sub-active-tab': $route.path.startsWith('/cloudtelephony/customtunes') }">
                    <router-link
                      class="nav-link"
                      to="/cloudtelephony/customtunes"
                      >Custom Tunes</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="nav-item"
              v-show="state.permission_fks.includes('68')"
              :class="{ 'active-tab': $route.path === '/generateaudio' }"
            >
              <router-link class="nav-link" to="/generateaudio"
                ><img
                  src="/assets/images/icon/campaign-menu-icon.svg"
                  class="navlink-tab-icon"
                  alt=""
                  width="16"
                />Generate Audio</router-link
              >
            </li>
            <li class="nav-item" v-show="state.permission_fks.includes('37')">
              <div
                :class="{ 'active-tab': $route.path.startsWith('/billing') }"
              >
                <button
                  class="btn btn-toggle align-items-center rounded collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#nav-system-billing-collapse"
                  aria-expanded="false"
                >
                  <img
                    src="/assets/images/icon/billing-menu-icon.svg"
                    class="navlink-tab-icon"
                    alt=""
                    width="16"
                  />Billing
                </button>
              </div>

              <div
                class="collapse"
                data-bs-parent="#accordionNavLinkParent"
                id="nav-system-billing-collapse"
              >
                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                  <li v-show="state.permission_fks.includes('38')" :class="{ 'sub-active-tab': $route.path.startsWith('/billing/dashboard') }">
                    <router-link class="nav-link" to="/billing/dashboard"
                      >Dashboard</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('39')" :class="{ 'sub-active-tab': $route.path.startsWith('/billing/invoice') }">
                    <router-link class="nav-link" to="/billing/invoice"
                      >Tax Invoices</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('40')" :class="{ 'sub-active-tab': $route.path.startsWith('/billing/statement') }">
                    <router-link class="nav-link" to="/billing/statement"
                      >Account Statement</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('41')" :class="{ 'sub-active-tab': $route.path.startsWith('/billing/receipt') }">
                    <router-link class="nav-link" to="/billing/receipt"
                      >Payment Receipts</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('34')" :class="{ 'sub-active-tab': $route.path.startsWith('/companydetails') }">
                    <router-link class="nav-link" to="/companydetails"
                      >Company Details</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>

            <!-- <li class="nav-item" v-show="state.permission_fks.includes('42')">
              <div
                :class="{ 'active-tab': $route.path.startsWith('/support') }"
              >
                <button
                  class="btn btn-toggle align-items-center rounded collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#nav-support-collapse"
                  aria-expanded="false"
                >
                  <img
                    src="/assets/images/icon/support-menu-icon.svg"
                    class="navlink-tab-icon"
                    alt=""
                    width="16"
                  />Support Tickets
                </button>
              </div>
              <div
                class="collapse"
                data-bs-parent="#accordionNavLinkParent"
                id="nav-support-collapse"
              >
                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                   <li v-show="state.permission_fks.includes('48')">
                    <router-link class="nav-link" to="/logs/whatsapplogs">WhatsApp Logs</router-link>
                  </li> 
                  <li v-show="state.permission_fks.includes('48')">
                    <router-link class="nav-link" to="/support/user"
                      >User Tickets</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('47')">
                    <router-link class="nav-link" to="/support/voter"
                      >Voter Tickets</router-link>
                    <router-link class="nav-link" to="/support/app"
                      >App Support Tickets</router-link
                </ul>
              </div>
            </li> -->
            <li class="nav-item" v-show="state.permission_fks.includes('75')">
              <div
                :class="{ 'active-tab': $route.path.startsWith('/appsupport') }"
              >
                <button
                  class="btn btn-toggle align-items-center rounded collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#nav-support-collapse"
                  aria-expanded="false"
                >
                  <img
                    src="/assets/images/icon/support-menu-icon.svg"
                    class="navlink-tab-icon"
                    alt=""
                    width="16"
                  />

                  <span class="text-start">App Support Ticket</span>
                </button>
              </div>
              <div
                class="collapse"
                data-bs-parent="#accordionNavLinkParent"
                id="nav-support-collapse"
              >
                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                  <li v-show="state.permission_fks.includes('76')" :class="{ 'sub-active-tab': $route.path.startsWith('/appsupport/new') }">
                    <router-link class="nav-link" to="/appsupport/new"
                      >New Tickets</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('77')" :class="{ 'sub-active-tab': $route.path.startsWith('/appsupport/open') }">
                    <router-link class="nav-link" to="/appsupport/open"
                      >Open Tickets</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('78')" :class="{ 'sub-active-tab': $route.path.startsWith('/appsupport/closed') }">
                    <router-link class="nav-link" to="/appsupport/closed"
                      >Closed Tickets</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('79')" :class="{ 'sub-active-tab': $route.path.startsWith('/appsupport/settings') }">
                    <router-link class="nav-link" to="/appsupport/settings"
                      >Settings</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>

            <!-- <li v-show="state.permission_fks.includes('47')">
              <router-link class="nav-link" to="/support/app"
                >App Support Tickets</router-link
              >
            </li> -->
            <!-- <li class="nav-item">
              <router-link class="nav-link" to="/opensms"><img src="/assets/images/icon/feedback-tab-icon.svg"
                  class="navlink-tab-icon" alt="" width="16" />Open SMS</router-link>
            </li> -->
            <li class="nav-item" v-show="state.permission_fks.includes('46')">
              <div :class="{ 'active-tab': $route.path.startsWith('/logs') }">
                <button
                  class="btn btn-toggle align-items-center rounded collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#nav-logs-collapse"
                  aria-expanded="false"
                >
                  <img
                    src="/assets/images/icon/system-logs-menu-icon.svg"
                    class="navlink-tab-icon"
                    alt=""
                    width="16"
                  />System Logs
                </button>
              </div>

              <div
                class="collapse"
                data-bs-parent="#accordionNavLinkParent"
                id="nav-logs-collapse"
              >
                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                  <!-- <li v-show="state.permission_fks.includes('48')">
                    <router-link class="nav-link" to="/logs/whatsapplogs">WhatsApp Logs</router-link>
                  </li> -->
                  <li v-show="state.permission_fks.includes('48')" :class="{ 'sub-active-tab': $route.path.startsWith('/logs/webbotlogs') }">
                    <router-link class="nav-link" to="/logs/webbotlogs"
                      >Web Bot Logs</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('47')" :class="{ 'sub-active-tab': $route.path.startsWith('/logs/sms') }">
                    <router-link class="nav-link" to="/logs/sms"
                      >SMS Logs</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('50')" :class="{ 'sub-active-tab': $route.path.startsWith('/logs/myincoming') }">
                    <router-link class="nav-link" to="/logs/myincoming"
                      >Incoming Logs</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('51')" :class="{ 'sub-active-tab': $route.path.startsWith('/logs/myoutgoing') }">
                    <router-link class="nav-link" to="/logs/myoutgoing"
                      >Outgoing Logs</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('46')" :class="{ 'sub-active-tab': $route.path.startsWith('/logs/rcs') }">
                    <router-link
                      class="nav-link disabled-router"
                      to="/underprogress"
                      >RCS Logs</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('46')" :class="{ 'sub-active-tab': $route.path.startsWith('/logs/imessage') }">
                    <router-link
                      class="nav-link disabled-router"
                      to="/underprogress"
                      >iMessage Logs</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('49')" :class="{ 'sub-active-tab': $route.path.startsWith('/logs/email') }">
                    <router-link class="nav-link" to="/logs/email"
                      >Email Logs</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('56')" :class="{ 'sub-active-tab': $route.path.startsWith('/logs/aadhaar-v1-card') }">
                    <router-link class="nav-link" to="/logs/aadhaar-v1-card"
                      >Aadhaar Logs</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('57')" :class="{ 'sub-active-tab': $route.path.startsWith('/logs/voter/_search') }">
                    <router-link class="nav-link" to="/logs/voter/_search"
                      >Voter Card Logs</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('58')" :class="{ 'sub-active-tab': $route.path.startsWith('/logs/pan-card') }">
                    <router-link class="nav-link" to="/logs/pan-card"
                      >Pan Card Logs</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('59')" :class="{ 'sub-active-tab': $route.path.startsWith('/logs/driving-licence') }">
                    <router-link class="nav-link" to="/logs/driving-licence"
                      >Driving Licence Logs</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('46')" :class="{ 'sub-active-tab': $route.path.startsWith('/logs/rto') }">
                    <router-link
                      class="nav-link disabled-router"
                      to="/underprogress"
                      >RTO Logs</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('60')" :class="{ 'sub-active-tab': $route.path.startsWith('/logs/passport') }">
                    <router-link class="nav-link" to="/logs/passport"
                      >Passport Logs</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('61')" :class="{ 'sub-active-tab': $route.path.startsWith('/logs/importvoter') }">
                    <router-link class="nav-link" to="/logs/importvoter"
                      >Import Logs</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>

            <li class="nav-item" v-show="state.permission_fks.includes('2')">
              <div
                :class="{ 'active-tab': $route.path.startsWith('/settings') }"
              >
                <button
                  class="btn btn-toggle align-items-center rounded collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#nav-settings-collapse"
                  aria-expanded="false"
                >
                  <span class="mr-auto"
                    ><img
                      src="/assets/images/icon/setting-menu-icon.svg"
                      class="navlink-tab-icon"
                      alt=""
                      width="16"
                    />Settings</span
                  >
                </button>
              </div>
              <div
                class="collapse"
                data-bs-parent="#accordionNavLinkParent"
                id="nav-settings-collapse"
              >
                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                  <li v-show="state.permission_fks.includes('3')">
                    <router-link class="nav-link" to="/settings/underprogress"
                      >API</router-link
                    >
                  </li>
                  <!-- <li v-show="state.permission_fks.includes('11')">
                    <router-link class="nav-link" to="/settings/underprogress"
                      >DLT</router-link
                    >
                  </li> -->
                  <!-- <li v-show="state.permission_fks.includes('4')">
                    <router-link class="nav-link" to="/settings/underprogress"
                      >Templates</router-link
                    >
                  </li> -->
                  <li v-show="state.permission_fks.includes('5')">
                    <router-link class="nav-link" to="/settings/underprogress"
                      >Offices</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('52')" :class="{ 'sub-active-tab': $route.path.startsWith('/settings/designation') }">
                    <router-link class="nav-link" to="/settings/designation"
                      >Designations</router-link
                    >
                  </li>
                  <li v-show="state.permission_fks.includes('35')" :class="{ 'sub-active-tab': $route.path.startsWith('/settings/tags') }">
                    <router-link class="nav-link" to="/settings/tags"
                      >Voter Tags</router-link
                    >
                  </li>
                  <!-- <li v-show="state.permission_fks.includes('36')">
                    <router-link class="nav-link" to="/settings/eventsettings"
                      >Event Settings</router-link
                    >
                  </li> -->
                  <li v-show="state.permission_fks.includes('70')" :class="{ 'sub-active-tab': $route.path.startsWith('/settings/ticketsettings') }">
                    <router-link class="nav-link" to="/settings/ticketsettings"
                      >Ticket Settings</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li
              v-show="state.permission_fks.includes('71')"
              class="nav-item"
              :class="{ 'active-tab': $route.path === '/jobopportunities' }"
            >
              <!-- v-show="state. .includes('70')" -->
              <router-link class="nav-link" to="/jobopportunities"
                ><img
                  src="/assets/images/icon/campaign-menu-icon.svg"
                  class="navlink-tab-icon"
                  alt=""
                  width="16"
                />Job Opportunities</router-link
              >
            </li>
            <li
              v-show="state.permission_fks.includes('72')"
              class="nav-item"
              :class="{ 'active-tab': $route.path === '/bloodbank' }"
            >
              <!-- v-show="state.permission_fks.includes('70')" -->
              <router-link class="nav-link" to="/bloodbank"
                ><img
                  src="/assets/images/icon/bloodbank.svg"
                  class="navlink-tab-icon"
                  alt=""
                  width="16"
                />Online Blood Bank</router-link
              >
            </li>
            <li
              v-show="state.permission_fks.includes('73')"
              class="nav-item"
              :class="{ 'active-tab': $route.path === '/plasma' }"
            >
              <!-- v-show="state.permission_fks.includes('70')" -->
              <router-link class="nav-link" to="/plasma"
                ><img
                  src="/assets/images/icon/bloodbank.svg"
                  class="navlink-tab-icon"
                  alt=""
                  width="16"
                />Online Plasma</router-link
              >
            </li>
            <li
              class="nav-item"
              :class="{ 'active-tab': $route.path === '/schemes' }"
              v-show="state.permission_fks.includes('74')"
            >
              <!-- v-show="state.permission_fks.includes('70')" -->
              <router-link class="nav-link" to="/schemes">
                <div class="d-flex">
                  <img
                    src="/assets/images/icon/system-logs-menu-icon.svg"
                    class="navlink-tab-icon"
                    alt=""
                    width="16"
                  />
                  <span> Government Schemes </span>
                </div>
              </router-link>
            </li>
            <li
              class="nav-item"
              :class="{ 'active-tab': $route.path === '/app-popup' }"
              v-show="state.permission_fks.includes('80')"
            >
              <!-- v-show="state.permission_fks.includes('70')" -->
              <router-link class="nav-link" to="/app-popup">
                <div class="d-flex">
                  <img
                    src="/assets/images/icon/svgrepo.svg"
                    class="navlink-tab-icon"
                    alt=""
                    width="16"
                  />
                  <span> App Popup </span>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </nav>
      <div class="copyright-outer mt-auto">
        <div class="copyright-inner">
          <div class="logo-outer">
            <img
              src="/assets/images/meraneta-logo-black.png"
              class="img-fluid"
              alt=""
              width="74"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, onMounted } from "vue";
import { useStore } from "vuex";
import commonFunctions from "../composables/commonFunction";

export default {
  setup() {
    const store = useStore();
    const { checkEmpty } = commonFunctions();

    const state = reactive({
      client_partylogo: "",
      client_name: "",
      client_info: "",
      sub_leader_logo: "",
      leader_logo: "",
      // permission_fks: localStorage.permission_fks,
      baseUrl: window.location.origin,
      billingaccess: "",
      client_partyname: "",
      permission_fks: store.state.loggedInUserSessions?.permission_fks,
    });

    onMounted(() => {
      let masterbucketname = store.state.masterbucketname;
      const loggedUserData = store.state.loggedInUserSessions;
      if (loggedUserData) {
        var whatsappmessageinput = loggedUserData.permission_fks.replaceAll(
          '"',
          ""
        );
        if (state.permission_fks) {
          state.permission_fks = whatsappmessageinput.split(",");
        } else {
          state.permission_fks = [];
        }
        var userData = loggedUserData.user;
        state.billingaccess = userData.ak40;
        state.client_info = loggedUserData.client_info;
        state.client_partyname = state.client_info.maa65;
        state.client_name = state.client_info.maa2;
        if (
          state.baseUrl == "http://localhost:8080" ||
          state.baseUrl == "http://localhost:8081"
        ) {
          state.client_path = state.client_info.maa24;
        } else {
          state.client_path = masterbucketname;
        }
        state.client_partylogo =
          "https://storage.googleapis.com/" +
          state.client_path +
          "/Client/Logo/" +
          state.client_info.maa6;

        state.sub_leader_logo =
          "https://storage.googleapis.com/" +
          state.client_path +
          "/Client/PartyLeaderLogo/" +
          state.client_info.maa66;

        // state.leader_logo =
        //   "https://storage.googleapis.com/" +
        //   state.client_path +
        //   "/Client/PartyLogo/" +
        //   state.client_info.maa47;
      }

      // store.dispatch('fetchDistricts');

      // store.dispatch('fetchBoothNumberList');
      // store.dispatch('fetchProfessions');
      // store.dispatch('fetchBloodGroups');
      // store.dispatch('fetchTags');
      // store.dispatch('fetchEmployerTypeList');
      // store.dispatch('fetchIndustries');
      // store.dispatch('fetchCompanyTypes');
      // store.dispatch('fetchFamilyRelations');
      // store.dispatch('fetchClientDesignations');
      // store.dispatch('fetchCountryCodeList');
      // store.dispatch('fetchEducationList');
      // store.dispatch('fetchAllTitles');
      // store.dispatch('fetchLokSabha');
      // store.dispatch('fetchCities');
      // store.dispatch('fetchStates');
      // store.dispatch('fetchActiveUsers');
    });

    return { state, checkEmpty };
  },
};
</script>
<style scoped>
.disabled-router {
  opacity: 0.5;
  pointer-events: none;
}
</style>
